import styled, { css } from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

const FOOTER_HEIGHT = 92 // 92 px is the min height of the footer, if it is more than that, flex-grow will help to grow the container

export const AiImageGenerateTabContent = styled.div`
  flex: 1;
  height: calc(100% - ${FOOTER_HEIGHT}px);
  padding: 0 16px 20px;

  overflow: hidden overlay;
  ${customizeVerticalScrollbarThumbMixin()}
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const OptionsRow = styled.div`
  display: flex;
  gap: 12px;

  & > div:first-child {
    max-width: 120px;
  }
`

export const AiImageGenerateOption = styled.div<{
  $gap?: number
  $disabled?: boolean
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ $gap }) => $gap || 8}px;
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.4;
    `}
`
